<template>
    <div>
        <template v-if="address">
            <template v-if="isAddressFieldEnabled('name1')">
                <div class="font-bold" v-if="address && address.name1 && address.name1.length > 0">
                    {{ address.name1 }}
                </div>
            </template>

            <template v-if="isAddressFieldEnabled('contactPerson')">
                <div>{{ address | optionType(12) }}</div>
            </template>

            <template v-if="isAddressFieldEnabled('title') || isAddressFieldEnabled('name2') || isAddressFieldEnabled('name3') || isAddressFieldEnabled('gender')">
                <div class="font-bold" v-if="!address.name1 || address.name1.length == 0">
<!--                    <template v-if="isAddressFieldEnabled('gender') && address.gender">-->
<!--                        {{ $translate('Ceres::Template.addressSalutation'+capitalizeFirstLetter(address.gender)) }}-->
<!--                    </template>-->
                    <template v-if="isAddressFieldEnabled('title')">{{ address | optionType(11) }}</template>
                    <template v-if="isAddressFieldEnabled('name2')">{{ address.name2 }}</template>
                    <template v-if="isAddressFieldEnabled('name3')">{{ address.name3 }}</template>
                </div>
            </template>

            <div v-if="isAddressFieldEnabled('name4')">{{ address.name4 }}</div>

            <div v-if="isAddressFieldEnabled('address1') || isAddressFieldEnabled('address2')">
                <template v-if="isAddressFieldEnabled('address1')">{{ address.address1 }}</template>
                <template v-if="isAddressFieldEnabled('address2')">{{ address.address2 }}</template>
            </div>

            <div v-if="isAddressFieldEnabled('address3')">
                <template v-if="address.address1 === 'PACKSTATION' || address.address1 === 'POSTFILIALE'">
                    {{ $translate("Ceres::Template.addressPostNummer") }}
                    {{address | optionType(6)}}
                </template>
                {{ address.address3 }}
            </div>

            <div v-if="isAddressFieldEnabled('address4')">
                {{ address.address4 }}
            </div>

            <div v-if="isAddressFieldEnabled('postalCode') || isAddressFieldEnabled('town')">
                <template v-if="isAddressFieldEnabled('postalCode')">{{ address.postalCode }}</template>
                <template v-if="isAddressFieldEnabled('town')">{{ address.town }}</template>
            </div>

            <div v-if="isAddressFieldEnabled('country')">
                {{ getCountryName(address.countryId) }}
            </div>
        </template>
    </div>
</template>

<script>

export default
{
    props: {
        address: {
            type: Object,
            required: true
        },
        addressFields:
            {
                type: Array,
                default: () => {
                    return [
                        "gender",
                        "title",
                        "contactPerson",
                        "name1",
                        "name2",
                        "name3",
                        "name4",
                        "address1",
                        "address2",
                        "address3",
                        "address4",
                        "postalCode",
                        "town",
                        "country"
                    ];
                }
            }
    },

    methods:
        {
            getCountryName(countryId) {
                return this.$store.getters.getCountryName(countryId);
            },

            isAddressFieldEnabled(fieldName) {
                return this.addressFields.includes(fieldName);
            },

            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        },

    filters:
        {
            optionType(selectedAddress, typeId) {
                // TODO DUPLICATE (Address Select) - move to vuex
                if (selectedAddress && selectedAddress.options) {
                    for (const optionType of selectedAddress.options) {
                        if (optionType.typeId === typeId) {
                            return optionType.value;
                        }
                    }
                }

                return "";
            }
        }
}
</script>
